import { SupermetaLogo } from '@shared/ui/icons'

// TODO: 기능 연동 필요 — 고객센터 이메일/카피라이트 텍스트는 정책에 따라 상수화 또는 i18n
const SUPPORT_EMAIL = 'SuperTrader.Manager@gmail.com'
const COPYRIGHT = 'Copyright@2023 SUPER META.All rights reserved'

export const PcFooter = () => (
  <footer className="flex h-[100px] w-full items-start justify-center overflow-hidden border-t-4 border-bg-grey bg-[#1b1c1d] pt-1">
    <div className="flex w-[1200px] items-start justify-between py-[30px]">
      <div className="flex flex-col items-start">
        <SupermetaLogo />
      </div>
      <div className="flex flex-col items-end gap-1">
        <span className="font-pretendard text-xs tracking-[-0.3px] text-font-gray">
          고객센터 : {SUPPORT_EMAIL}
        </span>
        <span className="font-pretendard text-xs tracking-[-0.3px] text-font-gray">
          {COPYRIGHT}
        </span>
      </div>
    </div>
  </footer>
)
